// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wHLe","right":"styles_right__30V-j"};